import { StatusEnvelope } from '@src/utils/enum/status-envelope';
import { SignatoryStatusEnum } from '@src/utils/enum/status-signatory';

export const envelopeColors = {
  [StatusEnvelope.Canceled]: '#A31A10',
  [StatusEnvelope.Expired]: '#979797',
  [StatusEnvelope.Process]: '#F9A826',
  [StatusEnvelope.Finished]: '#73CDA4',
};

export const signatoryColors = {
  [SignatoryStatusEnum.Finished]: '#73CDA4',
  [SignatoryStatusEnum.Canceled]: '#A31A10',
  [SignatoryStatusEnum.InSubscription]: '#F9A826',
  [SignatoryStatusEnum.Expired]: '#979797',
};
